import { useCallback, useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PageHeader, Empty } from "./ui";
import { errMsg } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

const ROLE_LABEL = { admin: "Administrador Geral", atendente: "Atendente (fase futura, sem acesso)", pendente: "Sem acesso" };

export default function Team() {
  const { api, me } = useOutletContext();
  const [data, setData] = useState(null);
  const load = useCallback(() => api.get("/users").then((r) => setData(r.data)).catch(() => setData(false)), [api]);
  useEffect(() => { load(); }, [load]);
  const setRole = async (uid, role) => {
    try { await api.patch(`/users/${uid}/role`, { role }); toast.success("Acesso atualizado."); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (me.role !== "admin") return <Empty>Somente administradores.</Empty>;
  return (
    <div className="flex h-full flex-col">
      <PageHeader title="Equipe" description="Quem entra no painel cria a própria conta em /admin/cadastro e aguarda aprovação aqui." />
      <div className="scroll-thin min-h-0 flex-1 overflow-y-auto">
        {data === null ? <Empty>Carregando…</Empty> : data === false ? <Empty>Não foi possível carregar.</Empty> : (
          <ul className="divide-y divide-zap-line bg-white">
            {data.users.map((u) => (
              <li key={u.user_id} data-testid={`team-user-${u.user_id}`} className="flex flex-wrap items-center gap-3 px-5 py-3 md:px-8">
                <div className="min-w-0 flex-1">
                  <p className="font-semibold">{u.name || u.email}</p>
                  <p className="text-sm text-muted-foreground">{u.email} · desde {fmtDateTime(u.created_at)}</p>
                </div>
                <Select value={u.role} onValueChange={(v) => setRole(u.user_id, v)}>
                  <SelectTrigger data-testid={`team-role-${u.user_id}`} className="w-56"><SelectValue /></SelectTrigger>
                  <SelectContent>{data.roles.map((r) => <SelectItem key={r} value={r}>{ROLE_LABEL[r]}</SelectItem>)}</SelectContent>
                </Select>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
